<form class="routed-component-layout" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off" *ngIf="form">
  <div class="routed-component-body">
    <div class="routed-component-title-block">
      <h2>{{ 'REGISTRATION.TERMS_CONDITIONS.TITLE' | translate }}</h2>
      <p>{{ 'REGISTRATION.TERMS_CONDITIONS.PARAGRAPH_1' | translate }}</p>
    </div>

    <div class="field-group-layout">
      @if (form.controls.cloudTerms) {
      <soldo-field-layout
        [control]="form.controls.cloudTerms"
        fieldName="cloudTerms"
        cypressSelector="TermsConditions_Checkbox_AcceptCloudTerms"
        >
      <ng-container input>
        <input id="ACCEPT_CLOUD_TERMS" type="checkbox" (value)="true" formControlName="cloudTerms">
        <label for="ACCEPT_CLOUD_TERMS">
          <span innerHTML="{{ 'REGISTRATION.TERMS_CONDITIONS.ACCEPT_CLOUD_TERMS' | translate: {value: termsLink} }}">{{ 'DEFAULT_EMPTY_STRING' | translate }}</span>
        </label>
      </ng-container>
        <ng-container errorMessage>
          <soldo-field-error error errorName="required">{{ 'TERMS_AGREEMENT' | translate }}</soldo-field-error>
        </ng-container>
      </soldo-field-layout>
      }

      <soldo-field-layout
        [control]="form.controls['financialTerms']"
        fieldName="financialTerms"
        cypressSelector="TermsConditions_Checkbox_AcceptFinancialTerms"
        >
        <ng-container input>
          <input id="ACCEPT_FINANCIAL_TERMS" type="checkbox" (value)="true" formControlName="financialTerms">
          <label for="ACCEPT_FINANCIAL_TERMS">
            <span innerHTML="{{ 'REGISTRATION.TERMS_CONDITIONS.ACCEPT_FINANCIAL_TERMS' | translate: {value: termsLink} }}">{{ 'DEFAULT_EMPTY_STRING' | translate }}</span>
          </label>
        </ng-container>
        <ng-container errorMessage>
          <soldo-field-error error errorName="required">{{ 'TERMS_AGREEMENT' | translate }}</soldo-field-error>
        </ng-container>
      </soldo-field-layout>

      @if (form.controls.startupConfirm) {
        <soldo-field-layout
          [control]="form.controls.startupConfirm"
          fieldName="startupConfirm"
          cypressSelector="TermsConditions_Checkbox_ConfirmProStartupPlan">

          <ng-container input>
            <input id="CONFIRM_PROSTARTUP" type="checkbox" (value)="true" formControlName="startupConfirm">
            <label for="CONFIRM_PROSTARTUP">
              <span innerHTML="{{ 'REGISTRATION.TERMS_CONDITIONS.PROSTARTUP' | translate }}">{{ 'DEFAULT_EMPTY_STRING' | translate }}</span>
            </label>
          </ng-container>
          <ng-container errorMessage>
            <soldo-field-error error errorName="required">{{ 'OTHER_AGREEMENT' | translate }}</soldo-field-error>
          </ng-container>
        </soldo-field-layout>
      }

      @if (form.controls.earlyAccessConfirm) {
        <soldo-field-layout
          [control]="form.controls.earlyAccessConfirm"
          fieldName="earlyAccessConfirm"
          cypressSelector="TermsConditions_Checkbox_ConfirmEarlyAccess"
          >
          <ng-container input>
            <input id="CONFIRM_EARLY_ACCESS" type="checkbox" (value)="true" formControlName="earlyAccessConfirm">
            <label for="CONFIRM_EARLY_ACCESS">
              <span innerHTML="{{ 'REGISTRATION.TERMS_CONDITIONS.EARLY_ACCESS_CONFIRM' | translate }}">{{ 'DEFAULT_EMPTY_STRING' | translate }}</span>
            </label>
          </ng-container>
          <ng-container errorMessage>
            <soldo-field-error error errorName="required">{{ 'OTHER_AGREEMENT' | translate }}</soldo-field-error>
          </ng-container>
        </soldo-field-layout>
      }
    </div>

    <div class="callout informative">
      <div class="callout-content">
        @if (isDirectSales) {
          <p>{{ 'REGISTRATION.TERMS_CONDITIONS.PARAGRAPH_2_DS' | translate }}</p>
        } @else {
          <p>{{ 'REGISTRATION.TERMS_CONDITIONS.PARAGRAPH_2' | translate }}</p>
        }
      </div>
    </div>

    <div>
      <button type="button" class="link no-padding" (click)="$event.preventDefault(); onShowCode()" data-cy="TermsConditions_Button_ShowDiscountCode">
        {{ 'REGISTRATION.TERMS_CONDITIONS.DISCOUNT_CODE_LABEL' | translate }}
      </button>
      <div class="conditional-subfield-container" *ngIf="showCode">
        <soldo-field-layout
          [control]="form.controls['discountCode']"
          fieldName="discountCode"
          cypressSelector="TermsConditions_TextInput_DiscountCode"
          >
          <input input uppercase
            type="text"
            formControlName="discountCode"
            placeholder="{{ 'REGISTRATION.TERMS_CONDITIONS.DISCOUNT_CODE' | translate }}"
            >

          <ng-container errorMessage>
            <soldo-field-error error errorName="maxlength">
              {{ 'MAX_LENGHT' | translate: { value: form.controls.discountCode.errors?.maxlength.requiredLength } }}
            </soldo-field-error>
          </ng-container>
        </soldo-field-layout>
      </div>
    </div>
  </div>

  <div class="navigation-controls-layout">
    <div class="routed-component-cta">
      <button type="button" (click)="goToPrevious()" data-cy="TermsConditions_Button_StepBackButton">
        {{ 'PREVIOUS' | translate }}
      </button>
      <button type="submit" class="primary" [disabled]="loading" [ngClass]="{ 'loading': loading}"
        data-cy="TermsConditions_Button_StepSubmitButton">{{ 'REGISTRATION.TERMS_CONDITIONS.SUBMIT' | translate }}</button>
    </div>
  <save-and-continue-later stepName="Terms and Conditions"></save-and-continue-later>
  </div>

</form>

<div class="routed-component-layout" *ngIf="showSubmitFallback">
  <div class="routed-component-body">
    <div class="routed-component-title-block">
      <h2>{{ 'REGISTRATION.TERMS_CONDITIONS.SUBMIT_FALLBACK_TITLE' | translate }}</h2>
      <p>{{ 'REGISTRATION.TERMS_CONDITIONS.SUBMIT_FALLBACK_BODY' | translate }}</p>
    </div>
  </div>

  <div class="navigation-controls-layout">
    <div class="routed-component-cta">
      <button type="button" class="primary" (click)="retrySubmitFallback()" data-cy="TermsConditions_Button_RetrySubmitButton">
        {{ 'NEXT' | translate }}
      </button>
    </div>
  </div>
</div>
